import styles from "./ChatMessage.module.scss";
import React from "react";
import { MESSAGE_TYPES, SENDER_TYPES } from "../../domain/Message";
import ReactMarkdown from "react-markdown";
import classNames from "classnames";
import ImageWithThumbnail from "../widgets/ImageWithThumbnail";

export default (props) => {
  const message = props.message;

  if (message.senderType === SENDER_TYPES.HTML)
    return <div dangerouslySetInnerHTML={{ __html: message.text }}/>;

  if (message.type === MESSAGE_TYPES.IMAGE) {
    return <ImageWithThumbnail
      src={message.getSourceFromImage()}
      alt={message.getSourceFromImage()}
      className={styles.incomingImage}
      withoutThumbnail
    />
  }

  const className = message.isIncoming() ? styles.incoming : styles.outgoing;

  return <span onClick={props.onClick}>
    <ReactMarkdown
      source={message.text}
      className={classNames(props.className, className)}
    />
  </span>
};

